<template>
  <div class="mobile-wrapper">
    <div class="fixed-banner">
      <div class="container-fluid banner-alt">
        <div class="row">
          <div class="col-6 banner-title">
            <i class="material-icons md-36" @click="goOrder">keyboard_arrow_left</i>
            <span class="title-text" @click="goOrder">{{ $t('message.yourOrder') }}</span>
          </div>
          <div class="btn col-6 text-right">
            <a
              @click="clearAllOrders()"
              :style="mobileStyles.LinkColorTxt"
            >{{ $t('message.clearAll') }}</a>
          </div>
        </div>
      </div>
    </div>
    <!-- fixed-banner-double -->
    <div class="content-padding" />

    <div class="container mt-2">
      <div class="row cart-items" v-if="wholeOrderDiscount">
        <div
          :style="mobileStyles.successMsg"
          class="discount-container"
        >{{wholeOrderDiscountMessage}}</div>
      </div>
    </div>
    <div class="container-fluid cart-items-holder">
      <template v-for="(item, index) in cartItems">
        <cart-item :cart-item="item" :key="index" />
      </template>
    </div>

    <div class="col-sm-12" v-if="canshowRedemption">
      <div
        @click="addReedemption()"
        class="btn redeem-btn mb-2"
      >{{ $t('message.redeemStamps') }}: {{ canshowRedemption.Name }}</div>
    </div>
    <!-- /cart items -->
    <footer class="cart-footer">
      <div class="container-fluid">
        <div class="row mcart-totals" v-show="cartItems.length > 0 && cartValue > 0">
          <CouponComponent
            ref="couponComponent"
            :qrcode="qrcode"
            :ForMobile="true"
            :className="'mcart-totals'"
          ></CouponComponent>
        </div>
        <div class="row mcart-totals">
          <div class="col-6">{{ $t('message.subtotal') }}</div>
          <div class="col-6 mtotal-price">{{ subtotalPrice | formatMoney }}</div>
        </div>
        <div class="row mcart-totals">
          <div class="col-6">{{ $t('message.gst') }}</div>
          <div class="col-6 mtotal-price">{{ totaltax | formatMoney }}</div>
        </div>
        <div v-if="showDelivery" class="row mcart-totals">
          <div class="col-6">{{ $t('message.delivery') }}</div>
          <div class="col-6 mtotal-price">{{ deliveryFee | formatMoney }}</div>
        </div>
        <div class="row mcart-totals">
          <div class="col-6">{{ $t('message.discount') }}</div>
          <div class="col-6 mtotal-price">{{ discount | formatMoney }}</div>
        </div>

        <div class="row mcart-total">
          <div :class="getPoints?'col-6':'col-8'">{{ $t('message.totalIncGST') }}</div>
          <div v-if="getPoints" class="row" style="position: absolute; right: 15px;">
            <div>{{ totalPrice | formatMoney }}</div>
            <div
              class="text-success points"
            >({{ getStamps?getStamps :getPoints| formatNumber }} pts)</div>
          </div>
          <div v-else class="col-4 mtotal-price">{{ totalPrice | formatMoney }}</div>
        </div>
        <div
          v-if="!exceedMinPurchase && !storeClosed"
          class="p-2 text-danger text-center"
        >{{ $t('message.minimumPurchaseIs') }} {{ minPurchase | formatMoney }}</div>
        <div
          v-show="IsInOperationMessage && !store.IsInOperation"
          class="p-2 text-danger text-center"
        >{{IsInOperationMessage}}</div>
      </div>
      <div class="extras-footer">
        <router-link
          :to="{ name: 'store', params: {storeid: $route.params.storeid, storename: $route.params.storename } }"
          class="btn btn-cancel"
        >{{ $t('message.cancel') }}</router-link>
        <router-link
          :to="{ name:IsSaveOrder? 'saveOrderMobile':'checkout', params: {storeid: $route.params.storeid, storename: $route.params.storename } }"
          :class="{ disabled: orderDisbaled ? 'disabled' : '' }"
          class="btn btn-primary"
          :style="mobileStyles.btn"
        >{{ storeClosed ? "Store closed" :IsSaveOrder? 'Place Order':'Continue' }}</router-link>
      </div>
      <poweredby v-if="!isBranded()" />
    </footer>

    <modal ref="redemptionModal" v-if="showRedemption" full-header @close="closeModal" hide-footer>
      <template slot="body">
        <div style="height: calc(100vh - 150px); overflow-y: auto; margin-bottom: 50px;">
          <Modifiers
            @canceled="closeModal"
            :product="selectedReedemption.product"
            :modifiers="selectedReedemption.modifiers"
            :product-id="selectedReedemption.productId"
            @updated="selectRollIntoModiefiers"
            :is-submodifier="true"
            :has-confirm-button="true"
          />
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
//import { mapGetters, mapMutations, mapActions } from "vuex";
import CartItem from "./CartItemMobile";
import { getStore } from "../../../api/services/storeService.js";
import { IsStoreOpenAtTime } from "./../../../api/helpers/datetimeHelper.js";
import { DateTime } from "luxon";
import poweredby from "../../shared/poweredby";
import CouponComponent from "./CouponComponent";
//import uuid from "uuid/v1";
import modal from "../../modal";
import Modifiers from "../products/Modifiers";
import shared from "../../../sharedscripts/shop/shopping-cart/ShoppingCart.js";

// import {
//   priceTriggerType,
//   OutcomePriceType
// } from "../../../api/constants/priceTriggerEnums";
export default {
  name: "ShoppingCart",
  components: {
    CartItem,
    poweredby,
    CouponComponent,
    modal,
    Modifiers
  },
  props: {
    orderType: {
      type: Number,
      default: 3
    },
    qrcode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      store: {},
      storeClosed: false,
      timerId: null,
      minPurchase: 0,
      IsInOperationMessage: null,
      selectedReedemption: null,
      showRedemption: false,
      IsSaveOrder: false
    };
  },
  computed: {
    ...shared.computed
  },
  watch: {
    store(newValue) {
      this.storeClosed = !IsStoreOpenAtTime(newValue, DateTime.local());
      // IsClosedTimeOfStore(newValue) || !newValue.IsInOperation;
      this.computeRules(this.orderType);
    },
    orderType(newValue) {
      this.computeRules(newValue);
    },
    totalPrice() {
      this.computeRules(this.orderMode);
    },
    subtotalPrice() {
      this.initDeliveryInfo();
    },
    cartItems: {
      handler: function(newValue) {
        this.fixRedemptionQuantity(newValue);
      },
      deep: true
    }
  },

  created() {
    let that = this;
    getStore(this.$route.params.storeid).onSnapshot(
      function(doc) {
        if (doc.exists) {
          that.store = doc.data();
          that.IsInOperationMessage = "Store is not in operation.";
          if (that.store.ChargeToRoom) {
            that.destroyOldCard();
            that.timerId = setInterval(that.destroyOldCard, 5000);
          }
        }
      },
      function(reason) {
        that.insertErrorlog([
          reason.name,
          reason.toString(),
          that.$router.currentRoute.fullPath
        ]);
        that.redirectToErrorPage();
      }
    );
  },
  mounted() {
    let coupon = window.localStorage.getItem("coupon");
    if (coupon) {
      this.$refs.couponComponent.applyCoupon(coupon);
    }
    if (sessionStorage.getItem("paymenttype") == "saveorder")
      this.IsSaveOrder = true;
  },
  beforeDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  },
  methods: {
    ...shared.methods
  }
};
</script>